var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 399,
    viewBox: "0 0 848 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.07 215.999C357.407 150.379 415 -12.9997 825 10.5002",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 201L359.533 216.4L371.933 204",
    stroke: "white",
    strokeWidth: 1.95556
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.4 64L292 73.5333L304.4 85.9333",
    stroke: "white",
    strokeWidth: 1.95556
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M847 17.9593C777.923 9.58641 637.09 8.95844 626.373 73.4301",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M618 60.6611L626.164 73.8485L636.839 67.3595",
    stroke: "white",
    strokeWidth: 1.67459
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293 74C525.5 84.5004 415.5 -19 825.5 4.5",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImages);
export default __webpack_public_path__ + "static/media/arrow_images.007e62f1dcc90ccb16c4195be58e4459.svg";
export { ForwardRef as ReactComponent };